import InspectionDetailTabs from './InspectionDetailTabs.container';
export default InspectionDetailTabs;
